// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const FullRescanStepStatusSchema = z.enum(['TRIGGERED','SKIPPED','FAILED'] as const);

export type FullRescanStepStatusType = `${z.infer<typeof FullRescanStepStatusSchema>}`

export default FullRescanStepStatusSchema;
